module.exports = "<div class=\"items-per-page\">\n    {{ 'pagination.Show Per Page' | translate }}\n    <select\n        name=\"{{ vm.name }}\"\n        class=\"form-control\"\n        ng-model=\"vm.pageSize\"\n        ng-change=\"vm.changePageSize()\"\n    >\n        <option ng-repeat=\"option in vm.pageSizeOptions\" value=\"{{ option }}\">\n            {{ option }}\n        </option>\n    </select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paginationv2/tools/pageSize/template.html
// module id = 1641
// module chunks = 0